module.exports = __webpack_public_path__ + "static/ifgf-austin-tag1.97b81eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ifgf-austin-tag1.jpg
// module id = 487
// module chunks = 35783957827783